import { api } from "../api/api";
import { ApiResponse } from "../models/base/ApiResponse";
import { UpdateSettingsDTO } from "../models/settings/settings.request";
import { GetSettingsInfoDTO } from "../models/settings/settings.response";


export const settingsService = {

    async getSettingsInfo(): Promise<ApiResponse<GetSettingsInfoDTO>> {
        const {data} = await api.get<ApiResponse<GetSettingsInfoDTO>>('/settings');
        return data;
    },

    async updateSettings(settingsData: UpdateSettingsDTO): Promise<ApiResponse<string>> {
        const {data} = await api.put<ApiResponse<string>>('/settings', settingsData);
        return data;
    }

}